document.addEventListener("DOMContentLoaded", () => {
    const filtersForm = document.querySelector("form.filters-form")
    if (!filtersForm) return

    filtersForm.querySelectorAll(" li.input").forEach(li => {
        const div = createElement("div", {innerHTML: li.innerHTML, classList: li.classList})
        div.classList.remove("required")
        div.classList.add("optional")
        div.classList.add("filters-form-field")
        div.querySelector('abbr')?.remove()
        li.outerHTML = div.outerHTML
    })

    filtersForm.querySelectorAll("select").forEach(select => {
        select.classList.add("searchable-select")
    })

    filtersForm.querySelectorAll(".select.input.filters-form-field label").forEach(label => {
        label.innerText = label.innerText.replace(/ eq/g, '').replace(/ cont/g, '')
    })
})
